import type { Provider } from '@angular/core';
import { provideTranslocoScope } from '@jsverse/transloco';
import { i18nLoader } from './i18n-loader';

/**
 * Provides the transloco scope for the Company domain.
 *
 * Scope Details:
 * - Scope: 'company' (used in templates: t['company:key'])
 * - Translations: Located in i18n/[language].json files
 *
 * Translation Files:
 * - i18n/en.json - English translations
 * - i18n/ar.json - Arabic translations
 *
 * @returns Angular environment providers for transloco scope.
 * @see https://ngneat.github.io/transloco/docs/scope-resolution
 * @example Usage in components
 * ```ts
 * Component({
 *   providers: [provideTranslocoScopeCompany()]
 * })
 * export class CompanyFactoryCardComponent {}
 * ```
 */
export function provideTranslocoScopeCompany(): Provider {
  return provideTranslocoScope({ scope: 'company', loader: i18nLoader });
}
